/* *** Fevre River Database *** */
/* (C) 2026 - Joti Software, LLC */

// Keyword Picker Components //

import React, { Component } from 'react';
import { Button, FloatingLabel, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion, faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import produce from 'immer';

import Popover from './Popover';
import Tooltip from './Tooltip';

import './KeyWord.css';

// KeyWord
function KeyWord(props) {
	const variant = (props.selected) ? 'secondary' : 'outline-secondary';
	return (
		<div className="KeyWord">
			<Button variant={variant} size="sm" className="m-1" value={props.option} onClick={props.onClick}>{props.option}</Button>
		</div>
	);
}

// Keyword Picker
class KeyWordPicker extends Component {
	constructor(props) {
		super(props);
		
		this.handleClick = this.handleClick.bind(this);
		this.handleClearButtonClick = this.handleClearButtonClick.bind(this);

		this.state = {
			selectedOptions: [],
			action: {
				action: '',
				name: this.props.name,
				option: undefined
			}
		};
	}

	componentDidMount() {
		this.setState({ selectedOptions: this.props.value });
	}

	handleClick(clickedOption) {
		this.setState(produce(draftState => {
			const index = this.state.selectedOptions.indexOf(clickedOption);
			if (index > -1) {
				draftState.action.action = 'deselect-option';
				draftState.selectedOptions.splice(index, 1);
			}
			else {
				draftState.action.action = 'select-option';
				draftState.selectedOptions.push(clickedOption);
			}
		}), () => {
			this.props.onChange(this.state.selectedOptions, this.state.action);
		});
	}

	handleClearButtonClick() {
		this.setState(produce(draftState => {
				draftState.action.action = 'clear-all-options';
				draftState.selectedOptions = [];
		}), () => {
			this.props.onChange(this.state.selectedOptions, this.state.action)
		});
	}

	KeyWords() {
		return this.props.options.map((currentOption, i) => {
			const selected = this.state.selectedOptions.includes(currentOption);
			return <KeyWord key={currentOption} option={currentOption} selected={selected} onClick={() => this.handleClick(currentOption)} />;
		});
	}

	render() {
		return (
			<FloatingLabel label={this.props.label} className="mb-3">
				<Form.Group className={'KeyWordPicker mb-3' + ((this.state.selectedOptions.length > 0) ? ' active' : '')} controlId={this.props.controlId}>
					<div className="selected-label">
						&nbsp;
						{this.props.selectedLabel}
					</div>
					<Tooltip className="clear-button" placement="top" title="Clear Selection">
						<FontAwesomeIcon className="text-muted" icon={faCircleXmark} onClick={this.handleClearButtonClick} />
					</Tooltip>
					{
						(this.props.helpContent)
						?
						<Popover className="help-button" trigger="hover|focus" placement="right" title={this.props.helpTitle || 'Help'} content={this.props.helpContent}>
								<FontAwesomeIcon className="text-extra-muted fs-5" icon={faCircleQuestion} />
							</Popover>
						: ''
					}
					<div>
						{this.KeyWords()}
					</div>
				</Form.Group>
			</FloatingLabel>
		);
	}
}

export { KeyWord };
export default KeyWordPicker;